<template>
  <b-container fluid>
    <b-row class="mt-2">
      <b-col>
        <stat-filter-component
          :report-stat-function-handler="reportStatFunctionHandler"
          :from-date.sync="fromDate"
          :to-date.sync="toDate"
          :date-type.sync="dateType"
          :type-selected.sync="typeSelected"
          :filter-show.sync="filterShow"
          :filter-handler="filterHandler"
          :export-excel-handler="exportExcelHandler"
          :show-value.sync="showValue"
        />
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col xl="3">
        <stat-hospital-list-component
          :hospital-selected.sync="hospitalSelected"
        />
      </b-col>
      <b-col xl="9">
        <b-container id="result-stat" fluid>
          <b-row v-show="filterShow === 'all' || filterShow === 'graph'">
            <b-col id="chart-wrapper">
              <!-- graph -->
              <!--                            <stat-graph-component :graph-info="graphInfo" />-->
              <!--                            <canvas id="myChart" ></canvas>-->
            </b-col>
          </b-row>
          <b-row>
            <b-col> </b-col>
          </b-row>
          <b-row v-show="filterShow === 'all' || filterShow === 'table'">
            <b-col>
              <!--summary table -->
              <stat-filter-list-component
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :fields="filterFields"
                :price-by-date="priceByDate"
                :items="filterItems"
              />
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import StatFilterComponent from "../../components/Account/StatFilterComponent";
import StatHospitalListComponent from "../../components/Account/StatHospitalListComponent";
import StatFilterListComponent from "../../components/Account/StatFilterListComponent";
import StatGraphComponent from "../../components/Account/StatGraphComponent";
import { mapActions } from "vuex";
import printJS from "print-js";
import moment from "moment-timezone";
import Chart from "chart.js";
import Account from "../../services/API/Account";
import ChartDataLabels from "chartjs-plugin-datalabels";
import axios from "axios";

export default {
  name: "StatView",
  components: {
    StatFilterComponent,
    StatHospitalListComponent,
    StatFilterListComponent,
    // StatGraphComponent
  },
  data() {
    return {
      filterShow: "all",
      typeSelected: "finance",
      hospitalSelected: [],
      filterFields: [],
      filterItems: [],
      dateType: "month",
      fromDate: null,
      toDate: null,
      graphInfo: [],
      priceByDate: [],
      sortBy: "",
      sortDesc: false,
      myChart: null,
      isSending: false,
      showValue: false,
    };
  },
  async mounted() {
    // let dateNow = new Date()

    // this.fromDate = new Date(dateNow.getFullYear(), 0, 1);

    this.fromDate = new Date(moment().startOf("month"));
    this.toDate = new Date(moment().endOf("month"));
    // this.toDate = new Date(dateNow.getFullYear(), 11, 1)

    // await this.filter()
  },
  methods: {
    ...mapActions({
      statFilter: "Account/statFilter",
      uploadGraphImage: "Account/uploadGraphImage",
    }),
    async exportExcelHandler() {
      // let firstDate = new Date(this.fromDate.getFullYear(), this.fromDate.getMonth(), this.fromDate.getDate() +1)
      // let lastDate = new Date(this.toDate.getFullYear(), this.toDate.getMonth(), this.toDate.getDate() +1)
      let firstDate = moment(this.fromDate).format("DD-MM-YYYY");
      let lastDate = moment(this.toDate)
        .endOf("month")
        .format("DD-MM-YYYY");
      // let firstDate = new Date(this.fromDate.getFullYear(), this.fromDate.getMonth(), this.fromDate.getDate())
      // let lastDate = new Date(this.toDate.getFullYear(), this.toDate.getMonth() + 1, 0)

      firstDate = `${this.fromDate.getDate()}/${this.fromDate.getMonth() +
        1}/${this.toDate.getFullYear()}`;
      lastDate = `${this.toDate.getDate()}/${this.toDate.getMonth() +
        1}/${this.fromDate.getFullYear()}`;

      let resultImagePath = await this.uploadGraphImage(
        this.myChart.toBase64Image()
      );

      let items = [];

      this.filterItems.forEach((item) => {
        let itemObject = {};
        const keys = this.filterFields.map((field) => field.key);
        keys.forEach((key) => {
          itemObject[key] = item[key];
        });
        items.push(item);
      });

      let statPrint;
      try {
        statPrint = await Account.statExcel({
          items,
          fields: this.filterFields,
          sort_by: this.sortBy,
          sort_desc: this.sortDesc,
          type_selected: this.typeSelected,
          date_type: this.dateType,
          from_date: firstDate,
          to_date: lastDate,
          graph_url: resultImagePath.path,
          filter_show: this.filterShow,
          price_by_date: this.priceByDate,
        });
      } catch (err) {
        this.$swal.fire(err.message);
        return;
      }

      if (statPrint) {
        let newTab = window.open(
          `${process.env.VUE_APP_IP}/storage/${statPrint.url}`,
          "_blank"
        );
        axios({
          type: "POST",
          url: "/echo/json/",
          success: function(data) {
            newTab.location;
          },
        });
      } else {
        this.$swal.fire(statPrint);
        return;
      }

      // if (statPrint) {
      //   // let newTab = window.open(`${process.env.VUE_APP_IP}/storage/${statPrint.url}`, '_blank');
      //   let newTab = window.open(`${statPrint.url}`, "_blank");
      //   newTab.focus();
      // } else {
      //   this.$swal.fire(statPrint);
      //   return;
      // }
    },
    filterHandler() {
      switch (this.dateType) {
        case "month":
          this.$nextTick(() => {
            this.dateFormat = "MMM yyyy";
            this.fromDate = moment(this.fromDate)
              .startOf("month")
              .toDate();
            this.toDate = moment(this.toDate)
              .endOf("month")
              .toDate();
            this.filter();
          });

          break;
        case "year":
          this.$nextTick(() => {
            this.dateFormat = "yyyy";
            this.fromDate = moment(this.fromDate)
              .startOf("year")
              .toDate();
            this.toDate = moment(this.toDate)
              .endOf("year")
              .toDate();
            this.filter();
          });

          break;
        case "date":
          this.$nextTick(() => {
            // console.log("todate", this.toDate);
            this.dateFormat = "dd MMM yyyy";
            this.fromDate = moment(this.fromDate)
              .startOf("day")
              .toDate();
            this.toDate = moment(this.toDate)
              .endOf("day")
              .toDate();

            this.filter();
          });

          break;
      }
    },
    filterGraph() {
      // let label = this.graphInfo.rows.map(el => el.date)

      this.$nextTick(() => {
        let chartWrapper = document.getElementById("chart-wrapper");
        chartWrapper.innerHTML = "";
        // const canvas = document.createElement('canvas');
        // canvas.id = 'mychart'
        chartWrapper.innerHTML = `<canvas id="myChart" ></canvas>`;

        let ctx = document.getElementById("myChart");
        ctx.height = 500;

        let datasets = this.graphInfo.rows.map((el) => {
          // let colorSet = el.data.map(e => '#' + (0x1000000 + (Math.random()) * 0xffffff).toString(16).substr(1, 6))
          let color =
            "#" +
            (0x1000000 + Math.random() * 0xffffff).toString(16).substr(1, 6);
          return {
            ...el,
            backgroundColor: color,
            // borderColor: el.data.map(e => '#' + (0x1000000 + (Math.random()) * 0xffffff).toString(16).substr(1, 6)),
            borderColor: color,
            fill: false,
            lineTension: 0,
            // backgroundColor: [
            //   'rgba(255, 99, 132, 0.2)',
            //   'rgba(54, 162, 235, 0.2)',
            //   'rgba(255, 206, 86, 0.2)',
            //   'rgba(75, 192, 192, 0.2)',
            //   'rgba(153, 102, 255, 0.2)',
            //   'rgba(255, 159, 64, 0.2)'
            // ],
            // borderColor: [
            //   'rgba(255, 99, 132, 1)',
            //   'rgba(54, 162, 235, 1)',
            //   'rgba(255, 206, 86, 1)',
            //   'rgba(75, 192, 192, 1)',
            //   'rgba(153, 102, 255, 1)',
            //   'rgba(255, 159, 64, 1)'
            // ],
            borderWidth: 1,
          };
        });
        let columns = this.graphInfo.columns;
        if (this.graphInfo.columns.length === 1) {
          columns = ["", ...this.graphInfo.columns, ""];
          datasets.forEach((data) => {
            data.data = [0, ...data.data, 0];
          });
        }

        const showValue = this.showValue;

        if (!showValue) {
          Chart.plugins.unregister(ChartDataLabels);
        } else {
          Chart.plugins.register(ChartDataLabels);
        }

        // Chart.plugins.register({
        //   afterDatasetsDraw: function(chartInstance, easing) {
        //     // To only draw at the end of animation, check for easing === 1
        //     var ctx = chartInstance.chart.ctx;

        //     // console.log(showValue);
        //     if (!showValue) {
        //       return;
        //     }

        //     chartInstance.data.datasets.forEach(function(dataset, i) {
        //       var meta = chartInstance.getDatasetMeta(i);
        //       if (!meta.hidden) {
        //         meta.data.forEach(function(element, index) {
        //           // Draw the text in black, with the specified font
        //           ctx.fillStyle = "rgb(0, 0, 0)";

        //           var fontSize = 16;
        //           var fontStyle = "normal";
        //           var fontFamily = "Helvetica Neue";
        //           ctx.font = Chart.helpers.fontString(
        //             fontSize,
        //             fontStyle,
        //             fontFamily
        //           );

        //           // Just naively convert to string for now
        //           var dataString = dataset.data[index].toString();

        //           // Make sure alignment settings are correct
        //           ctx.textAlign = "center";
        //           ctx.textBaseline = "middle";

        //           var padding = 5;
        //           var position = element.tooltipPosition();
        //           if (showValue) {
        //             ctx.fillText(
        //               dataString,
        //               position.x,
        //               position.y - fontSize / 2 - padding
        //             );
        //           }
        //         });
        //       }
        //     });
        //   },
        // });

        this.myChart = new Chart(ctx, {
          type: "line",
          tooltips: {
            enabled: false,
          },
          data: {
            labels: columns,
            // labels: ["", "ยอดรวมเงิน"],
            lineTension: 0,
            datasets,
          },
          options: {
            plugins: {
              // Change options for ALL labels of THIS CHART
              datalabels: {
                color: "#36A2EB",
                align: "end",
                anchor: "end",
              },
            },
            elements: {
              line: {
                tension: 0,
              },
            },
            responsive: true,
            maintainAspectRatio: false,
            title: {
              display: true,
              text: "กราฟแสดงยอดรวมทั้งหมด",
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    // beginAtZero: true
                  },
                },
              ],
              xAxes: [
                {
                  gridLines: {
                    offsetGridLines: true,
                  },
                },
              ],
            },
          },
        });
      });
    },
    async filter() {
      this.$nextTick(async () => {
        this.$store.state.isLoading = true;

        if (this.isSending) {
          return;
        }

        this.isSending = true;

        let firstDate = moment(this.fromDate).format("DD-MM-YYYY");
        let lastDate = moment(this.toDate).format("DD-MM-YYYY");

        // let firstDate = new Date(this.fromDate.getFullYear(), this.fromDate.getMonth(), this.fromDate.getDate())
        // let lastDate = new Date(this.toDate.getFullYear(), this.toDate.getMonth() + 1, 0)
        let resultFilter = await this.statFilter({
          type: this.typeSelected,
          hospital_selected:
            this.hospitalSelected.length > 0
              ? this.hospitalSelected[0].id
              : null,
          start_date: firstDate,
          end_date: lastDate,
          date_type: this.dateType,
        });

        if (!resultFilter.success) {
          this.$bvToast.toast(`${resultFilter.errors}`, {
            title: "ผิดพลาด",
            autoHideDelay: 5000,
            variant: "danger",
          });
        } else {
          this.filterFields = resultFilter.result.fields;
          this.filterItems = resultFilter.result.items;
          this.graphInfo = resultFilter.result.graph_info;
          this.priceByDate = resultFilter.result.totalPriceByDate
            ? resultFilter.result.totalPriceByDate
            : [];

          this.filterGraph();
        }
        this.$store.state.isLoading = false;
        this.isSending = false;
      });
    },
    async reportStatFunctionHandler() {
      // let firstDate = new Date(this.fromDate.getFullYear(), this.fromDate.getMonth(), this.fromDate.getDate() +1)
      // let lastDate = new Date(this.toDate.getFullYear(), this.toDate.getMonth(), this.toDate.getDate() +1)
      let firstDate = moment(this.fromDate).format("DD-MM-YYYY");
      let lastDate = moment(this.toDate)
        .endOf("month")
        .format("DD-MM-YYYY");
      // let firstDate = new Date(this.fromDate.getFullYear(), this.fromDate.getMonth(), this.fromDate.getDate())
      // let lastDate = new Date(this.toDate.getFullYear(), this.toDate.getMonth() + 1, 0)
      let typeSelect = this.typeSelected;
      let hospitalSelected = this.hospitalSelected;
      let dateType = this.dateType;

      let graphUrl = `${document.location.host}/graphStat?start_date=${firstDate}&end_date=${lastDate}&type=${typeSelect}&hospital_selected=${hospitalSelected}&date_type=${dateType}&filter_show=${this.filterShow}`;

      firstDate = `${this.fromDate.getDate()}/${this.fromDate.getMonth() +
        1}/${this.toDate.getFullYear()}`;
      lastDate = `${this.toDate.getDate()}/${this.toDate.getMonth() +
        1}/${this.fromDate.getFullYear()}`;

      let resultImagePath = await this.uploadGraphImage(
        this.myChart.toBase64Image()
      );

      let items = [];

      this.filterItems.forEach((item) => {
        let itemObject = {};
        const keys = this.filterFields.map((field) => field.key);
        keys.forEach((key) => {
          itemObject[key] = item[key];
        });
        items.push(item);
      });

      let statPrint;
      try {
        statPrint = await Account.statPrint({
          items,
          fields: this.filterFields,
          sort_by: this.sortBy,
          sort_desc: this.sortDesc,
          type_selected: this.typeSelected,
          date_type: this.dateType,
          from_date: firstDate,
          to_date: lastDate,
          graph_url: resultImagePath.path,
          filter_show: this.filterShow,
          price_by_date: this.priceByDate,
        });
      } catch (err) {
        this.$swal.fire(err.message);
        return;
      }

      if (statPrint) {
        // let newTab = window.open(`${process.env.VUE_APP_IP}/storage/${statPrint.url}`, '_blank');
        let newTab = window.open(`${statPrint.url}`, "_blank");
        newTab.focus();
      } else {
        this.$swal.fire(statPrint);
        return;
      }

      // let uri = `report-stat?items=${JSON.stringify(this.filterItems)}&fields=${JSON.stringify(this.filterFields)}&sort_by=${this.sortBy}&sort_desc=${this.sortDesc}&type_selected=${this.typeSelected}&date_type=${this.dateType}&from_date=${firstDate}&to_date=${lastDate}&graph_url=${resultImagePath.path}`;

      // console.log(this.myChart.toBase64Image(), 'base')
      // printJS({printable:`${process.env.VUE_APP_IP}${uri}`, type:'pdf', showModal:true})

      // printJS('result-stat', 'html')
    },
  },
  watch: {
    hospitalSelected(newValue, oldValue) {
      this.filter();
    },
    dateType(newValue, oldValue) {
      // this.$nextTick(() => {
      //   switch (newValue) {
      //     case 'month':
      //       this.$nextTick(() => {
      //         this.dateFormat = 'MMM yyyy';
      //         this.fromDate = moment()
      //           .startOf('month')
      //           .toDate();
      //         this.toDate = moment()
      //           .endOf('month')
      //           .toDate();
      //         this.filter();
      //         console.log('date type month change');
      //       });
      //       break;
      //     case 'year':
      //       this.$nextTick(() => {
      //         this.dateFormat = 'yyyy';
      //         this.fromDate = moment()
      //           .startOf('year')
      //           .toDate();
      //         this.toDate = moment()
      //           .endOf('year')
      //           .toDate();
      //         this.filter();
      //         console.log('date type year change');
      //       });
      //       break;
      //     case 'date':
      //       this.$nextTick(() => {
      //         this.dateFormat = 'dd MMM yyyy';
      //         this.fromDate = moment()
      //           .startOf('month')
      //           .toDate();
      //         this.toDate = moment()
      //           .endOf('month')
      //           .toDate();
      //         this.filter();
      //         console.log('date type date change');
      //       });
      //       break;
      //   }
      // });
    },
    fromDate(newValue, oldValue) {
      // this.filter();
    },
    toDate(newValue, oldValue) {
      // this.filter();
    },
    typeSelected(newValue, oldValue) {
      // this.filter();
    },
    filterShow(newValue, oldValue) {
      this.filterGraph();
    },
  },
};
</script>

<style scoped></style>
